import React from 'react';

// On phones the page becomes a fixed, app-like screen: the page itself never scrolls, only the content
// area does (IMP-087). Pages using it put "App App--shell" on their root (styles in BigFiveForm.css).
export default function useAppShell() {
    React.useEffect(() => {
        document.documentElement.classList.add('is-app-shell');
        return () => document.documentElement.classList.remove('is-app-shell');
    }, []);
}
